// Lightweight global signal for a transient "connection degraded" state.
// Reliable pollers (notification bell, dashboard stats) call reportConnectionStatus
// when a request serves a resilient fallback (response.degraded) or fails outright;
// the ConnectionStatusIndicator in the top bar shows a subtle icon while any source
// is degraded and hides again on the next clean poll.
export const CONNECTION_STATUS_EVENT = 'connection-status';

export function reportConnectionStatus(source, degraded) {
  window.dispatchEvent(
    new CustomEvent(CONNECTION_STATUS_EVENT, {
      detail: { source, degraded: !!degraded },
    })
  );
}
